import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEvArticle } from 'site-modules/editorial/utils/ev';
import { TreehousePromotionCheck } from 'site-modules/shared/components/treehouse-promotion/treehouse-promotion-check';
import { ReadyForEvTreehouse } from 'site-modules/shared/components/ready-for-ev/ready-for-ev';

import './article-treehouse-promotion.scss';

export function ArticleTreehousePromotion({ className = null, categories = [], slug, fallback = null }) {
  if (!isEvArticle({ slug, categories })) {
    return fallback;
  }

  return (
    <TreehousePromotionCheck fallback={fallback}>
      <div className={classnames('article-treehouse-promotion bg-cool-gray-90 px-1 py-1 rounded-12', className)}>
        <ReadyForEvTreehouse
          className="bg-white rounded-12 px-1_5 py-1_5 mx-auto"
          heading="Am I Ready for an EV?"
          creativeId="treehouse-promotion"
        />
      </div>
    </TreehousePromotionCheck>
  );
}

ArticleTreehousePromotion.propTypes = {
  slug: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  fallback: PropTypes.node,
};
